module.exports = __webpack_public_path__ + "img/action_plan_.023e3a02.png";